import React, { Fragment, ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesFormError from './form-error.styles';

const FormError: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    withOffset,
    withLeftOffset,
    withShowError,
    error,
  } = props;

  const { classes } = useStylesFormError();

  const leftOffsetClassName: string | undefined = withLeftOffset || withOffset
    ? classes.formErrorLeftOffset : undefined;
  const topOffsetClassName: string | undefined = withOffset ? classes.formErrorTopOffset : undefined;

  return (
    <Fragment>
      {
        !!error && withShowError && (
          <div className={FormatService.formatClassNames(classes.formError, leftOffsetClassName, topOffsetClassName)}>
            {error}
          </div>
        )
      }
    </Fragment>
  );
});

export default FormError;
